export const CANCEL_QUOTE = "CANCEL_QUOTE";
export const CANCEL_QUOTE_SUCCESS = "CANCEL_QUOTE_SUCCESS";
export const CANCEL_QUOTE_ERROR = "CANCEL_QUOTE_ERROR";
export const CANCEL_QUOTE_CLEAR_DATA = "CANCEL_QUOTE_CLEAR_DATA";
